import 'slick-carousel'
const [ d ] = [ document ]

export default function LENRI_SLIDER ( opt = {container:"",prev:"",next:""} ) {
  const _constructor = () => {
    const containers = d.querySelectorAll(opt.container)
    if(containers.length >= 1) Array.prototype.map.call( containers, slider_init )
  }

  const slider_init = container => {
    $(container).on('init breakpoint', () => {
      $('.slick-slide [class$="slider-item"] > img').each( (i,item) => {
        item.parentNode.style.backgroundImage = `url(${item.src})`
      })
    })
    $(container).slick({
      dots: true,
      arrows: false,
      fade: true,
      variableWidth: false,
      slidesToShow: 1,
      autoplay: true,
      pauseOnHover: false,
      speed: 2000,
      prevArrow: (opt.prev)? $(opt.prev) : '',
      nextArrow: (opt.next)? $(opt.next) : '',
      responsive: [
        {
          breakpoint: 768,
          settings: {
            dots: false,
            arrows: false,
          }
        }
      ]
    })
  }

  d.addEventListener('DOMContentLoaded',_constructor)
}